
import settings from '@/settings'


export default {
    method: 'post',

    baseUrl: settings.baseUrl + "automatic/",

    // 请求头信息
    headers: {
        'Content-Type': 'application/json;charset=UTF-8'
    },
    // 参数
    data: {},
    // 设置超时时间
    timeout: 180000,//180秒
    // 携带凭证
    withCredentials: false,
    // 返回数据类型
    responseType: 'json'
}